export const GET_POYNT_SETTINGS_STARTED = "GET_POYNT_SETTINGS_STARTED"
export const GET_POYNT_SETTINGS_SUCCESS = "GET_POYNT_SETTINGS_SUCCESS"
export const GET_POYNT_SETTINGS_FAILURE = "GET_POYNT_SETTINGS_FAILURE"

export const CREATE_POYNT_SALE_STARTED = "CREATE_POYNT_SALE_STARTED"
export const CREATE_POYNT_SALE_SUCCESS = "CREATE_POYNT_SALE_SUCCESS"
export const CREATE_POYNT_SALE_FAILURE = "CREATE_POYNT_SALE_FAILURE"

export const CANCEL_POYNT_SALE_STARTED = "CANCEL_POYNT_SALE_STARTED"
export const CANCEL_POYNT_SALE_SUCCESS = "CANCEL_POYNT_SALE_SUCCESS"
export const CANCEL_POYNT_SALE_FAILURE = "CANCEL_POYNT_SALE_FAILURE"

export const SET_DEFAULT_DEVICE_POYNT_STARTED = "SET_DEFAULT_DEVICE_POYNT_STARTED"
export const SET_DEFAULT_DEVICE_POYNT_SUCCESS = "SET_DEFAULT_DEVICE_POYNT_SUCCESS"
export const SET_DEFAULT_DEVICE_POYNT_FAILURE = "SET_DEFAULT_DEVICE_POYNT_FAILURE"

export const DISCONNECT_POYNT_STARTED = "DISCONNECT_POYNT_STARTED"
export const DISCONNECT_POYNT_SUCCESS = "DISCONNECT_POYNT_SUCCESS"
export const DISCONNECT_POYNT_FAILURE = "DISCONNECT_POYNT_FAILURE"

export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"